export class CostReviewElectricalComments {
  comments!: string;
}
